import React from "react";
import MapLocation from "../Components/MapLocation";
import "../pages/About.css";

const About = () => {
  return (
    <div className="about-us">
      <h1>O Nama</h1>
      <p>
        Wolf Enterijeri je firma sa više od 25 godina iskustva u proizvodnji 
        pločastog namještaja i opremanju enterijera. Naša posvećenost kvalitetu,
        inovaciji i modernom dizajnu omogućila nam je da postanemo prepoznatljiv 
        lider u industriji.
      </p>
      <p>
        Specijalizovani smo za proizvodnju vrhunskog, funkcionalnog i estetski 
        privlačnog namještaja, koji odgovara potrebama i željama savremenih korisnika. 
        Kroz konstantno ulaganje u napredne tehnologije i stručnost naših timova,
        svaki proizvod koji izlazi iz naših proizvodnih pogona odlikuje se dugotrajnim 
        kvalitetom, preciznošću i elegancijom.
      </p>
      <p>
        Naša ponuda obuhvata širok spektar proizvoda za privatne i poslovne prostore. 
        Pored proizvodnje namještaja, pružamo i usluge opremanja enterijera, sa ciljem
        da svaki prostor bude funkcionalan, udoban i vizuelno atraktivan. Misija naše 
        firme je da ponudimo vrhunski dizajn i kvalitet po meri svakog klijenta, stvarajući
        prostore koji odražavaju njihov stil i potrebe. Kroz inovativne pristupe i 
        personalizovane usluge, želimo biti pouzdan partner u kreiranju modernih i 
        funkcionalnih enterijera.
      </p>
      <p>
        Vizija Wolf Enterijeri je da nastavimo sa širenjem na tržištu i jačanjem našeg 
        brenda kao sinonima za kvalitetan i moderan namještaj. Naša posvećenost stalnom 
        unapređenju omogućava nam da ispunimo visoke standarde koji se postavljaju pred nas.
      </p>
      <div className="about-container">
        <div className="about-info">
          <h2>Tvornička 6, Sarajevo</h2>
          <h2>wolfenterijeri@gmail.com</h2>
          <h2>033 628-925</h2>
        </div>

        <MapLocation />
      </div>
    </div>
  );
};

export default About;
